import { Component, Input, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormGroup, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { RegistrationService } from './registration.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { accountInfo } from '../../types/accountInfo';
import { registrationInfo } from '../../types/registrationInfo';
import { environment } from '../../../environments/environment';
import { registrationListInfo } from '../../types/registrationListInfo';
import { mailInfo } from '../../types/mailInfo';
import { JwtService } from '../../shared/services/jwt/jwt.service';
import jwt_decode from 'jwt-decode';
import { MessagePopupComponent } from '../../shared/components/message-popup/message-popup.component';
import { PopupService } from '../../core/services/popup/popup.service';

export interface FormModel {
  captcha?: string;
}

@Component({
    selector: 'app-registration',
    templateUrl: './registration.component.html',
    styleUrls: ['./registration.component.sass'],
    standalone: false
})

export class RegistrationComponent {
  profInfo = false;
  termCond = false;
  trueInfo = false;
  notValidContent = false;
  diallingCode: any;
  language = '';
  notMessageValidContent = false;
  postalCodeError = false;
  countryName = '';
  errorMessage = '';
  registrationForm: FormGroup;
  accountTypes: string[] = [
    'ACCOUNT_TYPE_3_LABEL',
    'ACCOUNT_TYPE_LABEL3',
    'ACCOUNT_TYPE_LABEL2',
    'ACCOUNT_TYPE_LABEL4',
    'ACCOUNT_TYPE_LABEL5',
    'ACCOUNT_TYPE_LABEL6',
  ];
  ACCOUNT_TYPE_LABEL3_FLEET = 1;
  ACCOUNT_TYPE_LABEL2_TECHNICAL_COLLEGE = 2;
  ACCOUNT_TYPE_3_LABEL_AUTO_REPAIRER = 0;
  ACCOUNT_TYPE_LABEL5_PUBLISHER = 4;
  ACCOUNT_TYPE_LABEL4_ADMINISTRATION = 3;
  ACCOUNT_TYPE_LABEL6_VHU_ICPE = 5;
  // Mapping from UI index (0-5) to service accountId (1,2,0,4,3,5)
  private accountIndexToIdMap = [3, 1, 2, 5, 4, 7];
  accountTypeDescriptions: string[] = [
    'ACCOUNT_TYPE_DESC1',
    'ACCOUNT_TYPE_DESC3',
    'ACCOUNT_TYPE_DESC2',
    'ACCOUNT_TYPE_DESC4',
    'ACCOUNT_TYPE_DESC5',
    'ACCOUNT_TYPE_DESC6',
  ];
  accountTypeSecLines: string[] = [
    '',
    '',
    'ACCOUNT_TYPE_LABEL2_BIS',
    '',
    '',
    'ACCOUNT_TYPE_LABEL6_BIS',
  ];
  icons: string[] = [
    'garage-elevator',
    'car-fleet',
    'warranty',
    'user-group',
    'file-mechanics',
    'config-update',
  ];
  dataLinkEn = 'https://www.renault.co.uk/personal-data.html';
  dataLinkFr = 'https://www.renault.fr/donnees-personnelles.html';
  selectedAccountTypeIndex = -1;
  accountList: accountInfo[] = [];
  countryList: any[] = [];
  countryCode: any;
  countryId: any;
  selectedRegion = '';
  hasError = false;
  vatVerified = false;
  showVATError = true;
  vatValue = '';
  sirenValue = '';
  eInvoiceModel:any;
  noErrorStateMatcher: ErrorStateMatcher = { isErrorState: () => false };
  sirenVatMismatch = false;
  languageList: any[] = [
    { langCode: 'fr', langName: 'Français' },
    { langCode: 'en', langName: 'English' },
  ];
  showVatForEurope = false;
  showVatForOther = false;
  registrationInfo: registrationInfo[] = [];
  mailObject: mailInfo = new mailInfo();
  todayDate = '';
  vatValidateError = true;
  accountTypeList: any;
  accountId: any;
  submitted = false;
  selectedAccountType = '';
  @Input() value: string[] = [];
  @Input() defaultAccount: any;
  @ViewChild('registrationForm') signupForm: NgForm;
  showVatField = false;
  isLoader = false;
  termAndConditionLink = '';
  eInvoice = 'SR';
  EInvoiceValue = '';
  einvoiceAddressLineVerified = false;
  einvoiceAddressLineError = false;
  einvoicingList: any[] = [
    { value: 'SR', label: 'SIREN' }, { value: 'SRST', label: 'SIREN+SIRET' }, 
    { value: 'SRSTRC', label: 'SIREN+SIRET+ROUTING CODE' }, { value: 'SRSF', label: 'SIREN+SUFFIX' }
  ];

  constructor(
    private registrationListInfo: registrationListInfo,
    private popupService: PopupService,
    private translate: TranslateService,
    private userInfo: registrationInfo,
    public router: Router,
    private registrationService: RegistrationService,
    private jwtService: JwtService,
    private translateService: TranslateService,
    private cdr: ChangeDetectorRef) {
      this.getAccountDocumentTypes();
      this.getCountryList();
      this.getTodayDate();
      this.getFaqHelpDocs();
  }
 

  onAccountTypeSelect(index: number, accountType: string) {
    this.selectedAccountTypeIndex = index;
    this.selectedAccountType = this.translate.instant(accountType);
    if(this.signupForm) {
      this.signupForm.reset();
    }
    this.sirenValue = '';
    this.sirenVatMismatch = false;
    this.vatValue = '';
    this.vatVerified = false;
    this.showVATError = true;
    this.vatValidateError = true;
    this.showVatField = false;
    this.eInvoice = 'SR';
    this.EInvoiceValue = '';
    this.einvoiceAddressLineVerified = false;
    this.einvoiceAddressLineError = false;
    this.notValidContent = false;
    this.notMessageValidContent = false;
  }

 
  get dataLink() {
    return this.translate.currentLang.toUpperCase() === 'FR'
      ? this.dataLinkFr : this.dataLinkEn;
  }
  getFaqHelpDocs() {
    this.termAndConditionLink = environment.bucket_public_url + `Terms_and_Conditions_ASOS_${this.translate.currentLang.toUpperCase()}_June_2026.pdf`;
  }
  resetForm() {
    if(this.signupForm && this.registrationForm) {
      this.registrationForm.reset();
    }
    this.selectedAccountTypeIndex = -1;
    this.router.navigate(['/home']);
  }
  removeEmailError() {
    this.errorMessage = '';
  }
  checkTextPattern() {
    let pattern = /<script[\s\S]*?>[\s\S]*?<\/script>/gi;
    let patternCheck;
    patternCheck = pattern.test(this.signupForm.value.address);
    if(patternCheck) {
      this.notValidContent = true;
    } else {
      this.notValidContent = false;
    }
  }
  checkMessageTextPattern() {
    let pattern = /<script[\s\S]*?>[\s\S]*?<\/script>/gi;
    let patternCheck;
    patternCheck = pattern.test(this.signupForm.value.message);
    if(patternCheck) {
      this.notMessageValidContent = true;
    } else {
      this.notMessageValidContent = false;
    }
  }
  getAccountDocumentTypes() {
    this.isLoader = true;
    this.registrationService.getAccountType().subscribe((res: any) => {
        this.isLoader = false;
        this.cdr.detectChanges();
        let encryptData = res;
        let accountData: any = jwt_decode(encryptData);
        let response = accountData.accountTypeList;
        if(response) {
          this.accountList = response;
        }
        this.removeAccountType();
      },
      (err: any) => {
        this.isLoader = false;
        this.cdr.detectChanges();
      },
    );
  }
  removeAccountType() {
    this.accountList.splice(this.accountList.length - 2, 1);
    this.accountTypeList = this.accountList.filter(
      (item) => item.accountId != this.defaultAccount,
    );
  }
  getCountryList() {
    this.isLoader = true;
    this.registrationService.getCountries().subscribe(
      (response: any) => {
        this.isLoader = false;
        this.cdr.detectChanges();
        let encryptData = response;
        let countryData: any = jwt_decode(encryptData);
        this.countryList = countryData.countryDetailsList;
        this.countryList = this.countryList.filter(
          (item) =>
            item.countryId !== 178 &&
            (item.region == 'EUR' ||
              item.countryId == 3 ||
              item.countryId == 6 ||
              item.countryId == 14 ||
              item.countryId == 28 ||
              item.countryId == 74 ||
              item.countryId == 81 ||
              item.countryId == 85 ||
              item.countryId == 88 ||
              item.countryId == 91 ||
              item.countryId == 93 ||
              item.countryId == 97 ||
              item.countryId == 103 ||
              item.countryId == 104 ||
              item.countryId == 107 ||
              item.countryId == 108 ||
              item.countryId == 123 ||
              item.countryId == 127 ||
              item.countryId == 135 ||
              item.countryId == 138 ||
              item.countryId == 142 ||
              item.countryId == 144 ||
              item.countryId == 154 ||
              item.countryId == 162 ||
              item.countryId == 180 ||
              item.countryId == 185 ||
              item.countryId == 193 ||
              item.countryId == 201 ||
              item.countryId == 211 ||
              item.countryId == 223 ||
              item.countryId == 228 ||
              item.countryId == 230 ||
              item.countryId == 243 ||
              item.countryId == 244),
        );
        this.countryList.sort((a, b) =>
          a.countryName > b.countryName ? 1 : -1,
        );
      },
      (err: any) => {
        this.isLoader = false;
        this.cdr.detectChanges();
      },
    );
  }
  getTodayDate() {
    let today = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1;
    let yyyy = today.getFullYear();
    let date, month;
    if(dd < 10) {
      date = '0' + dd;
    } else {
      date = dd;
    }
    if(mm < 10) {
      month = '0' + mm;
    } else {
      month = mm;
    }
    this.todayDate = yyyy + '-' + month + '-' + date;
  }
  countryChange(val: any) {
    this.vatValue = '';
    this.vatValidateError = true;
    this.sirenVatMismatch = false;
    if(val !== undefined && val !== '') {
      const selectedCountry = this.countryList.filter(
        (country: any) => country.countryCode === val,
      );
      console.log(selectedCountry);
      if(selectedCountry && selectedCountry[0].vatRequired) {
        this.showVatField = true;
      } else {
        this.showVatField = false;
      }
      this.countryName = selectedCountry[0].countryName;
      this.diallingCode = '+' + selectedCountry[0].dialingCode;
      this.countryCode = selectedCountry[0].countryCode;
      this.countryId = selectedCountry[0].countryId;
      this.showVatForEurope = selectedCountry[0].vatRequired;
      this.selectedRegion = selectedCountry[0].region;
      // E-invoice verification only applies to French territories.
      this.einvoiceAddressLineVerified = !['FR', 'GP', 'MQ', 'RE'].includes(this.countryCode);
    }
    if((this.showVatForEurope || this.showVatForOther ||
        this.selectedAccountTypeIndex === this.ACCOUNT_TYPE_LABEL2_TECHNICAL_COLLEGE ||
        this.selectedAccountTypeIndex === this.ACCOUNT_TYPE_LABEL5_PUBLISHER ||
        this.selectedAccountTypeIndex === this.ACCOUNT_TYPE_LABEL4_ADMINISTRATION ||
        this.selectedAccountTypeIndex === this.ACCOUNT_TYPE_LABEL6_VHU_ICPE) && this.vatValue !== '') {
      this.vatVerified = true;
    } else if((!this.showVatForEurope || !this.showVatForOther ||
        this.selectedAccountTypeIndex === this.ACCOUNT_TYPE_LABEL3_FLEET ||
        this.selectedAccountTypeIndex === this.ACCOUNT_TYPE_3_LABEL_AUTO_REPAIRER) && this.vatValue !== '') {
      this.vatVerified = true;
    } else {
      this.vatVerified = false;
    }
    if(this.showVatForEurope && this.showVatForOther && this.vatValue !== '') {
      this.vatVerified = true;
    }
  }

  validateVAT() {
    if(this.vatValue !== '') {
      let countryCode = this.countryCode;
      if(this.countryCode === 'GR') {
        countryCode = 'EL';
      } else if(this.countryCode === 'GP' || this.countryCode === 'MQ' ||
        this.countryCode === 'MC' || this.countryCode === 'RE') {
        countryCode = 'FR';
      } else {
        countryCode = this.countryCode;
      }
      let request: any = { countryCode: countryCode, vatNumber: this.vatValue };
      let vatRequest: string = this.jwtService.encode(request, 'secret');
      this.isLoader = true;
      this.registrationService.checkVat(vatRequest).subscribe(
        (response: any) => {
          this.isLoader = false;
          let encryptData = response;
          let vatUpdateData: any = jwt_decode(encryptData);
          this.vatVerified = vatUpdateData.vatApproxDetails.valid;
          this.showVATError = vatUpdateData.vatApproxDetails.valid;
          this.vatValidateError = true;
          this.cdr.detectChanges();
        },
        (err: any) => {
          this.isLoader = false;
          if(err.status === 500) {
            this.popupService.openDialog(MessagePopupComponent, {
              data: { message: this.translate.instant('VAT_SERVICE_DOWN_MSG') },
            });
          }
          this.vatVerified = false;
          this.showVATError = false;
          this.vatValidateError = true;
          this.cdr.detectChanges();
        },
      );
    }
  }

  validateEinvoiceAddressLine() {
    if(this.EInvoiceValue !== '') {
      
      let request: any = { einvoicingAddressLine: this.EInvoiceValue };
      let einvoiceAddressLineRequest: string = this.jwtService.encode(request, 'secret');
      this.isLoader = true;
      this.registrationService.checkEinvoiceAddressLine(einvoiceAddressLineRequest).subscribe(
        (response: any) => {
          this.isLoader = false;
          let encryptData = response;
          let einvoiceAddressLineUpdateData: any = jwt_decode(encryptData);
          this.einvoiceAddressLineVerified =
            einvoiceAddressLineUpdateData.directoryLine.status === 'Enabled';
          this.einvoiceAddressLineError = !this.einvoiceAddressLineVerified;
          this.cdr.detectChanges();
        },
        (err: any) => {
          this.isLoader = false;
          this.einvoiceAddressLineVerified = false;
          this.einvoiceAddressLineError = true;
          this.cdr.detectChanges();
        },
      );
    }
  }

  submitRegistration() {
    this.hasError = false;
    this.isLoader = true;
    this.userInfo = new registrationInfo();
    // Map UI index to service accountId using the mapping array
    this.userInfo.accountId = this.accountIndexToIdMap[this.selectedAccountTypeIndex];
    this.userInfo.firstName = this.signupForm.value.firstName.trim();
    this.userInfo.lastName = this.signupForm.value.lastName.trim();
    this.userInfo.userMail = this.signupForm.value.userMail.toLowerCase();
    this.userInfo.password = this.signupForm.value.password;
    this.userInfo.companyName = this.signupForm.value.companyName;
    this.userInfo.state = this.signupForm.value.state;
    this.userInfo.postalCode = this.signupForm.value.postalCode;
    this.userInfo.address = this.signupForm.value.address;
    this.userInfo.registerNumber = this.signupForm.value.registerNumber;
    this.userInfo.languageCode = this.language;
    this.userInfo.countryId = this.countryId;
    this.userInfo.countryName = this.countryName;
    this.userInfo.diallingCode = this.diallingCode;
    this.userInfo.mobileNumber = this.signupForm.value.mobileNumber;
    this.userInfo.accessIdentifier = 'INDADMIN';
    this.userInfo.solidoNumber = '';
    this.userInfo.parentId = 0;
    this.userInfo.professional = this.profInfo;
    this.userInfo.regDate = this.todayDate;
    this.userInfo.trueInformation = this.trueInfo;
    this.userInfo.termsConditions = this.termCond;
    if(this.signupForm.value.consent == 'yes') {
      this.userInfo.personalDataAccess = true;
    } else {
      this.userInfo.personalDataAccess = false;
    }
    this.userInfo.ndAccess = true;
    this.userInfo.asmdorAccess = true;
    this.userInfo.rateLimit = 30;
    if(this.showVatField) {
      this.userInfo.vatCode = this.vatValue;
    } else {
      this.userInfo.vatCode = '';
    }
    if(this.countryId === 73 || this.countryId === 85 || this.countryId === 135 || this.countryId === 180 ) {
      if(this.selectedAccountTypeIndex === this.ACCOUNT_TYPE_LABEL3_FLEET ||
        this.selectedAccountTypeIndex === this.ACCOUNT_TYPE_3_LABEL_AUTO_REPAIRER) {
          this.userInfo.siret = this.signupForm.value.siret;
          this.userInfo.siren = this.sirenValue;
          this.userInfo.eInvoice = this.eInvoice;
          if(this.eInvoice === 'SRSTRC') {
            this.userInfo.routingCode = this.signupForm.value.routingCode;
          } else if(this.eInvoice === 'SRSF') {
            this.userInfo.suffix = this.signupForm.value.suffix;
          }
      }
      if(this.selectedAccountTypeIndex === this.ACCOUNT_TYPE_LABEL6_VHU_ICPE &&
        (this.countryId === 73 || this.countryId === 85 || this.countryId === 135 || this.countryId === 180 )) {
        this.userInfo.siret = this.signupForm.value.siret;
      }
    }
    if(this.selectedAccountTypeIndex === this.ACCOUNT_TYPE_LABEL2_TECHNICAL_COLLEGE ||
       this.selectedAccountTypeIndex === this.ACCOUNT_TYPE_LABEL5_PUBLISHER ||
       this.selectedAccountTypeIndex === this.ACCOUNT_TYPE_LABEL4_ADMINISTRATION ||
       this.selectedAccountTypeIndex === this.ACCOUNT_TYPE_LABEL6_VHU_ICPE) {
        this.mailObject = new mailInfo();
        // Map UI index to service accountId using the mapping array
        this.mailObject.accountId = this.accountIndexToIdMap[this.selectedAccountTypeIndex];
        this.mailObject.subject =
        this.selectedAccountType + ' ' + 'User Registration';
        this.mailObject.messageHead = 'User Details';
        this.mailObject.username =
        this.userInfo.firstName + ' ' + this.userInfo.lastName;
        this.mailObject.fromAddress = this.userInfo.userMail;
        this.mailObject.company = this.userInfo.companyName;
        this.mailObject.state = this.userInfo.state;
        this.mailObject.postalCode = this.userInfo.postalCode;
        this.mailObject.country = this.userInfo.countryName;
        this.mailObject.mobileNumber = this.userInfo.mobileNumber;
        this.mailObject.error = false;
        this.mailObject.errorMessage = '';
        this.mailObject.address = this.userInfo.address;
        this.mailObject.professional = this.profInfo;
        this.mailObject.trueInformation = this.trueInfo;
        this.mailObject.termsConditions = this.termCond;
        if(this.selectedAccountTypeIndex === this.ACCOUNT_TYPE_LABEL2_TECHNICAL_COLLEGE) {
          this.mailObject.paymentMethodForTechnical = this.signupForm.value.paymentMethodForTechnical;
        }
        if(this.signupForm.value.consent == 'yes') {
          this.mailObject.personalDataAccess = true;
        } else {
          this.mailObject.personalDataAccess = false;
        }
        if(this.selectedAccountTypeIndex === this.ACCOUNT_TYPE_LABEL6_VHU_ICPE) {
          this.mailObject.agrement = this.signupForm.value.agrement;
          if(this.countryId === 73) {
            this.mailObject.siret = this.signupForm.value.siret;
          }
          this.mailObject.isVHUICPE = true;
          this.mailObject.isSchool = false;
        } else {
          this.mailObject.userMessage = this.signupForm.value.message;
          this.mailObject.isSchool = true;
          this.mailObject.isVHUICPE = false;
        }
        if(this.language === 'fr') {
          this.mailObject.language = 'Français';
        } else {
          this.mailObject.language = 'English';
        }
        let mailData: string = this.jwtService.encode(this.mailObject, 'secret');
        this.registrationService.mailToAdmin(mailData).subscribe((response: any) => {
          this.isLoader = false;
          this.cdr.detectChanges();
          if(!response.error) {
            this.popupService.openDialog(MessagePopupComponent, {
              data: {
                message: this.translate.instant(
                  'EMAIL_REGISTRATION_SUCCESS_MSG',
                ),
              },
            });
          } else {
              this.popupService.openDialog(MessagePopupComponent, {
                data: { message: this.translate.instant('EMAIL_FAILURE') },
              });
            }
          });
        this.router.navigate(['/home']);
    } else {
      this.registrationInfo.push(this.userInfo);
      this.registrationListInfo.registrationsListDto = this.registrationInfo;
      let regData: string = this.jwtService.encode(
        this.registrationListInfo,
        'secret',
      );
      this.isLoader = true;
      this.registrationService.registerIndividualUser(regData, false).subscribe(
        (response: any) => {
          this.isLoader = false;
          this.cdr.detectChanges();
          this.registrationInfo = [];
          if(!(response as any[])[0].error) {
            this.hasError = (response as any[])[0].error;
            this.popupService.openDialog(MessagePopupComponent, {
              data: {
                message: this.translate.instant('REGISTRATION_SUCCESS_MSG'),
              },
            });
            this.router.navigate(['/home']);
          } else {
            this.hasError = response[0].error;
            if(this.hasError && response[0].errorMessage) {
              this.errorMessage = response[0].errorMessage;
            } else {
              this.errorMessage = this.translate.instant(
                'REGISTRATION_FAILURE_MSG',
              );
            }
            this.cdr.detectChanges();
          }
        },
        (error: any) => {
          this.isLoader = false;
          this.cdr.detectChanges();
          this.registrationInfo = [];
        },
      );
    }
  }
  vatNumberChanged() {
    if(this.vatVerified) {
      this.vatVerified = false;
      this.showVATError = false;
    }
    if(this.vatValue !== '') {
      this.vatValidateError = false;
    }
    this.checkSirenVatMatch();
  }

  appendToEinvoiceValue() {
    this.einvoiceAddressLineVerified = false;
    this.einvoiceAddressLineError = false;
    if(!this.sirenValue){
      this.EInvoiceValue = '';
      return;
    }
    if(this.eInvoice == 'SR') {
      this.EInvoiceValue = this.sirenValue;
    } else if(this.eInvoice == 'SRST') {
      this.EInvoiceValue = this.sirenValue + '_' + (this.signupForm.value.siret ? this.signupForm.value.siret: '');
    } else if(this.eInvoice == 'SRSTRC') {
      this.EInvoiceValue = this.sirenValue + '_' + (this.signupForm.value.siret ? this.signupForm.value.siret: '') + '_' + (this.signupForm.value.routingCode ? this.signupForm.value.routingCode: '');
    } else if(this.eInvoice == 'SRSF') {
      this.EInvoiceValue = this.sirenValue + '_' + (this.signupForm.value.suffix ? this.signupForm.value.suffix: '');
    }
  }

  checkSirenVatMatch() {
    if(this.vatValue && this.sirenValue && this.vatValue.length >= 9) {
      this.sirenVatMismatch = this.vatValue.slice(-9) !== this.sirenValue;
    } else {
      this.sirenVatMismatch = false;
    }
  }
  get dataPrivacyDoc(): string {
    return (
      environment.bucket_public_url +
      `DATA_PRIVACY_${this.translateService.currentLang.toUpperCase()}_V1.pdf`
    );
  }

}